import React from "react";
import { injectIntl } from "react-intl";
import Propertii from "../../common/Propertii";
import HyperwalletReport from "../../common/ReportHyperwallet";

class ReportHyperwallet extends Propertii {

    /**
     * Render the component.
     *
     * @returns {*} - Admin Hyperwallet report component.
     */
    render() {

        return(
            <HyperwalletReport companyId={this.props.match.params.companyId} />
        )
    };
}

export default injectIntl(ReportHyperwallet);